import { Textbox } from "components/form";
import { Box } from "components/ui";
import { router, usePathname } from "expo-router";
import { SearchIcon } from "lucide-react-native";
import React, { FC, useEffect, useState } from "react";
import { Modal, ScrollView, View } from "react-native";
import { User, useGetUserQuery } from "store/abcoApi";
import { SelectBaseProps } from "types/select.types";
import { useIsMobile } from "utils/hooks/useIsMobile";
import UserLabel from "./UserLabel";
import { Select } from "components/ui/select";

interface UserSelectProps extends SelectBaseProps {
	value?: User[];
	label?: string;
	isFluid?: boolean;
	options?: User[];
}

export const UserSelect: FC<UserSelectProps> = ({ onSelect, value, placeholder, label, isFluid, options }: UserSelectProps) => {
	const { data } = useGetUserQuery({ pageSize: 9999 });
	const [selectedUsers, setSelectedUsers] = useState<User[]>(value || []);

	let userList = data?.list;
	if (options) {
		userList = options;
	}

	useEffect(() => {
		if (value) {
			setSelectedUsers(value);
		}
	}, [value]);

	const handleSelectChange = (selectedOptions: any) => {
		// Extract user objects from the array of options
		const users = Array.isArray(selectedOptions) ? selectedOptions.map((option) => option.value) : [];

		setSelectedUsers(users);

		if (onSelect) {
			onSelect(users, 0);
		}
	};

	// Filter out already selected users from the options list
	const filteredUserList = userList
		? userList.filter((user) => {
				// Check if this user is already in the selectedUsers array
				return !selectedUsers.some((selectedUser) => selectedUser.id === user.id);
			})
		: [];

	const selectOptions = filteredUserList
		? filteredUserList.map((user: User) => ({
				value: user,
				label: `${user.firstName ?? ""} ${user.lastName ?? ""}`,
			}))
		: [];

	const selectedValue = selectedUsers.map((user) => ({
		value: user,
		label: `${user.firstName ?? ""} ${user.lastName ?? ""}`,
	}));

	return (
		<Box
			sx={{
				width: "$full",
				maxWidth: isFluid ? "auto" : 525,
			}}
		>
			<Select label={label} options={selectOptions} value={selectedValue} onChange={handleSelectChange} placeholder={placeholder || "Please select"} isMulti={true} isSearchable={true} isClearable={true} />
		</Box>
	);
};
